import React from 'react';
import { Panel, Label } from '@uhg-harmony/uitk-react';
import {
  Arrow,
  StyledPanelTitle,
} from 'builder/scenes/SiteBuilder/SettingsPanel/SettingsPanel';
import { Border } from 'builder/components/WidgetConfigurations/Border';
import { StyledPanel, SizeLocationPanel } from '../../Text/TextWidgetControl';
import {
  SizeLocationData,
  WidgetSizeLocation,
} from 'builder/components/WidgetSizeLocation';
import { Config } from './types';
import styled from 'styled-components';
import DropdownPanel from 'builder/components/WidgetConfigurations/Dropdown/DropdownPanel';

const PanelTop = styled.div`
  .jSWwIc {
    padding: 0;
    border: none;
  }
`;

const CheckboxButtonControl: React.FC<WidgetControlProps<Config>> = (
  props: WidgetControlProps<Config>
) => {
  const {
    value,
    onChange,
    widgetState,
    currentPage: { layoutLocked },
  } = props;

  const handleLineColor = (data: string) => {
    onChange({
      ...value,
      lineColor: data,
    });
  };

  const handleRequiredCheck = (data: boolean) => {
    onChange({
      ...value,
      required: data,
    });
  };

  const handleInputValues = (data: string) => {
    onChange({
      ...value,
      value: data,
    });
  };

  const handleLabel = (data: string) => {
    onChange({
      ...value,
      label: data,
    });
  };

  const handleButtonColor = (data: string) => {
    onChange({
      ...value,
      buttonColor: data,
    });
  };

  const updateWidgetSizeLocation = (sizeLoc: SizeLocationData) => {
    onChange({
      ...value,
      width: sizeLoc.width,
      height: sizeLoc.height,
      xLocation: sizeLoc.xLocation,
      yLocation: sizeLoc.yLocation,
      uniqueId: sizeLoc.uniqueId,
    });
  };

  const updateBorderData = (data: BorderData) => {
    onChange({
      ...value,
      borderData: data,
    });
  };

  return (
    <>
      <Panel.Group>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>General</Label>}
            icon={Arrow}
            data-test-id="general-panel"
          >
            <PanelTop>
              <DropdownPanel
                data-test-id="checkbox-dropdown-panel"
                disabled={layoutLocked}
                handleFieldRequirement={handleRequiredCheck}
                handleFieldLabel={handleLabel}
                handleSelectValues={handleInputValues}
                handleIconColor={handleButtonColor}
                widgetState={widgetState}
                pages={props.pages}
                site={props.site}
                updateSite={props.updateSite}
                saveSite={props.saveSite}
              />
            </PanelTop>
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <SizeLocationPanel
            title={<Label style={StyledPanelTitle}>Size and Location</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="checkbox-size-location-panel"
          >
            <WidgetSizeLocation
              data-test-id="checkbox-widget-size-location"
              disabled={layoutLocked}
              sizeLocation={{
                xLocation: value.xLocation,
                yLocation: value.yLocation,
                width: value.width,
                height: value.height,
                uniqueId: value.uniqueId,
              }}
              updateWidgetSizeLocation={updateWidgetSizeLocation}
              activeWidgetId={widgetState.id}
            />
          </SizeLocationPanel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            data-test-id="checkbox-border-panel"
            title={<Label style={StyledPanelTitle}>Border</Label>}
            initiallyClosed
            icon={Arrow}
          >
            <Border
              data-test-id="checkbox-border"
              updateBorderData={updateBorderData}
              disabled={layoutLocked}
              handleLineColor={handleLineColor}
              widgetState={widgetState}
              pages={props.pages}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </StyledPanel>
      </Panel.Group>
    </>
  );
};

export default CheckboxButtonControl;
